var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcontasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.69678C10 5.28256 10.3358 4.94678 10.75 4.94678H19.25C19.6642 4.94678 20 5.28256 20 5.69678V6.19678C20 6.61099 19.6642 6.94678 19.25 6.94678H10.75C10.3358 6.94678 10 6.61099 10 6.19678V5.69678Z",
    fill: "#3B5118"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.75C10 11.3358 10.3358 11 10.75 11H19.25C19.6642 11 20 11.3358 20 11.75V12.25C20 12.6642 19.6642 13 19.25 13H10.75C10.3358 13 10 12.6642 10 12.25V11.75Z",
    fill: "#3B5118"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.8027C10 17.3885 10.3358 17.0527 10.75 17.0527H19.25C19.6642 17.0527 20 17.3885 20 17.8027V18.3027C20 18.7169 19.6642 19.0527 19.25 19.0527H10.75C10.3358 19.0527 10 18.7169 10 18.3027V17.8027Z",
    fill: "#3B5118"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.44678C5.22386 5.44678 5 5.67063 5 5.94678C5 6.22292 5.22386 6.44678 5.5 6.44678C5.77614 6.44678 6 6.22292 6 5.94678C6 5.67063 5.77614 5.44678 5.5 5.44678ZM3 5.94678C3 4.56607 4.11929 3.44678 5.5 3.44678C6.88071 3.44678 8 4.56607 8 5.94678C8 7.32749 6.88071 8.44678 5.5 8.44678C4.11929 8.44678 3 7.32749 3 5.94678Z",
    fill: "#3B5118"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 11.5C5.22386 11.5 5 11.7239 5 12C5 12.2761 5.22386 12.5 5.5 12.5C5.77614 12.5 6 12.2761 6 12C6 11.7239 5.77614 11.5 5.5 11.5ZM3 12C3 10.6193 4.11929 9.5 5.5 9.5C6.88071 9.5 8 10.6193 8 12C8 13.3807 6.88071 14.5 5.5 14.5C4.11929 14.5 3 13.3807 3 12Z",
    fill: "#3B5118"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 17.5527C5.22386 17.5527 5 17.7766 5 18.0527C5 18.3289 5.22386 18.5527 5.5 18.5527C5.77614 18.5527 6 18.3289 6 18.0527C6 17.7766 5.77614 17.5527 5.5 17.5527ZM3 18.0527C3 16.672 4.11929 15.5527 5.5 15.5527C6.88071 15.5527 8 16.672 8 18.0527C8 19.4334 6.88071 20.5527 5.5 20.5527C4.11929 20.5527 3 19.4334 3 18.0527Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcontasks);
export default __webpack_public_path__ + "static/media/icon.tasks.fd5ef8c56f110bad30af6fa2f2b53536.svg";
export { ForwardRef as ReactComponent };